<template>
  <div class="about">
    <h1>This is a Projects page</h1>
  </div>
</template>

<script>
export default {
  name:"Projects",
}
</script>
